(() => {

  function initEditorialSlideshow() {

    const slideshows = document.querySelectorAll('.do-editorial-slideshow[data-editorial="true"]');

    slideshows.forEach((slideshow) => {

      if (slideshow.dataset.editorialReady) return;

      let attempts = 0;

      const wait = setInterval(() => {

        attempts++;

        const flkty = Flickity.data(slideshow);

        if (!flkty) {

          if (attempts > 100) {
            clearInterval(wait);
          }

          return;

        }

        clearInterval(wait);

        slideshow.dataset.editorialReady = "true";

        /* ------------------------------------
           Pause autoplay on hover
        ------------------------------------ */

        if (window.innerWidth > 767 && slideshow.dataset.autoplay) {

          slideshow.addEventListener('mouseenter', () => {

            flkty.pausePlayer();

          });

          slideshow.addEventListener('mouseleave', () => {

            flkty.playPlayer();

          });

        }

        /* ------------------------------------
           Pause when outside viewport
        ------------------------------------ */

        if (slideshow.dataset.autoplay) {

          const observer = new IntersectionObserver((entries) => {

            entries.forEach((entry) => {

              if (entry.isIntersecting) {

                flkty.playPlayer();

              } else {

                flkty.pausePlayer();

              }

            });

          }, {

            threshold:0.35

          });

          observer.observe(slideshow);

        }

      },50);

    });

  }

  document.addEventListener('DOMContentLoaded', initEditorialSlideshow);

  document.addEventListener('shopify:section:load', initEditorialSlideshow);

})();